/**
 * Build-a-Box Bundle Builder (Template B)
 * State management, Recharge SDK integration, and cart submission
 */
(function initMealBuilder() {
  'use strict';
  if (window.__babDisposeBuilder) window.__babDisposeBuilder();
  var lifecycle = new AbortController();
  window.__babDisposeBuilder = function () {
    lifecycle.abort();
  };
  if (window.Shopify && window.Shopify.designMode && !window.__babDisposeBuilderEditor) {
    window.__babDisposeBuilderEditor = true;
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('#build-a-box')) initMealBuilder();
    });
  }


  /* ========================================================================
     Config — injected from Liquid via <script type="application/json">
     ======================================================================== */
  const configEl = document.getElementById('build-a-box-config');
  if (!configEl) return;

  let CONFIG;
  try {
    CONFIG = JSON.parse(configEl.textContent);
  } catch (e) {
    console.error('[BuildABox] Failed to parse config:', e);
    return;
  }

  /* ========================================================================
     State
     ======================================================================== */
  const state = {
    quantityTier: null,
    purchaseType: 'subscribe',
    selections: {},
    selectedVariantId: null,
    sellingPlanId: null,
    totalSelected: 0,
    isValid: false,
  };

  /* ========================================================================
     DOM References
     ======================================================================== */
  const section = document.getElementById('build-a-box');
  if (!section) return;

  const tierCards = section.querySelectorAll('[data-bab-tier]');
  const purchaseCards = section.querySelectorAll('[data-bab-purchase-type]');
  const flavorCards = section.querySelectorAll('[data-bab-flavor]');
  const progressFill = section.querySelector('[data-bab-progress-fill]');
  const progressCount = section.querySelector('[data-bab-progress-count]');
  const progressLabel = section.querySelector('[data-bab-progress-label]');
  const summaryItems = section.querySelector('[data-bab-summary-items]');
  const summaryEmpty = section.querySelector('[data-bab-summary-empty]');
  const summaryTotal = section.querySelector('[data-bab-summary-total]');
  const summaryPerMeal = section.querySelector('[data-bab-summary-per-meal]');
  const summaryUpsellBottle = section.querySelector('[data-bab-summary-upsell]');
  const preorderNotice = section.querySelector('[data-bab-preorder-notice]');
  const addToCartBtn = section.querySelector('[data-bab-add-to-cart]');
  const errorEl = section.querySelector('[data-bab-error]');
  const stepFlavors = section.querySelector('[data-bab-step-flavors]');
  const stepPurchase = section.querySelector('[data-bab-step-purchase]');

  // Mobile bar
  const mobileBar = document.querySelector('.bab-mobile-bar');
  const mobilePrice = mobileBar ? mobileBar.querySelector('[data-bab-mobile-price]') : null;
  const mobileProgress = mobileBar ? mobileBar.querySelector('[data-bab-mobile-progress]') : null;
  const mobileBtn = mobileBar ? mobileBar.querySelector('[data-bab-mobile-btn]') : null;

  // Purchase type price elements
  const subscribePriceEl = section.querySelector('[data-bab-subscribe-price]');
  const onetimePriceEl = section.querySelector('[data-bab-onetime-price]');

  /* ========================================================================
     Helpers
     ======================================================================== */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Whole dollars when even, two decimals when fractional (e.g. $76, $101.60)
  function formatMoneyShort(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  // Subscribe and one-time both use the SAME product (the one the PDP lives on).
  // The only difference is whether a selling plan is attached at add-to-cart:
  // subscriptions attach CONFIG.sellingPlanId, one-time attaches nothing.
  function getVariantForTier(tier) {
    return CONFIG.variants.find(function (v) {
      return v.quantity === tier;
    });
  }

  function getSubscriptionPricing(tier) {
    return CONFIG.subscriptionPricing ? CONFIG.subscriptionPricing[String(tier)] : null;
  }

  function getPriceForTier(tier, type) {
    var variant = getVariantForTier(tier);
    if (!variant) return 0;
    if (type === 'subscribe') {
      var subPricing = getSubscriptionPricing(tier);
      if (subPricing) return subPricing.firstOrder;
    }
    return variant.price;
  }

  function getRecurringPrice(tier) {
    var subPricing = getSubscriptionPricing(tier);
    return subPricing ? subPricing.recurring : 0;
  }

  function getPerMealPrice(tier, type) {
    var total = getPriceForTier(tier, type);
    return Math.round(total / tier);
  }

  function showError(msg) {
    if (errorEl) {
      errorEl.textContent = msg;
      errorEl.classList.add('is-visible');
    }
    var mobileError = document.querySelector('[data-bab-mobile-error]');
    if (mobileError) {
      mobileError.textContent = msg;
      mobileError.classList.add('is-visible');
      if (mobileBar) mobileBar.classList.remove('bab-mobile-bar--hidden');
    }
  }

  function hideError() {
    if (errorEl) {
      errorEl.classList.remove('is-visible');
    }
    var mobileError = document.querySelector('[data-bab-mobile-error]');
    if (mobileError) mobileError.classList.remove('is-visible');
  }

  // Escape a value being interpolated into an HTML attribute inside innerHTML.
  function escapeAttr(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function flavorTitleForHandle(handle) {
    var match = (CONFIG.flavors || []).find(function (f) {
      return f.handle === handle;
    });
    return match ? match.title : '';
  }

  /* The compare price element wraps a visually-hidden "Regular price" label, so
     the amount is written into the inner value span — replacing the element's
     whole textContent would delete that label. Falls back to the element itself
     if the markup ever lacks the inner span. */
  function setCompareText(el, text) {
    var valueEl = el.querySelector('[data-bab-compare-value]');
    if (valueEl) {
      valueEl.textContent = text;
    } else {
      el.textContent = text;
    }
  }

  /* ------------------------------------------------------------------------
     Keyboard activation for the role="button" selector cards
     ------------------------------------------------------------------------
     The tier and purchase-type cards are <div role="button" tabindex="0">, so
     the browser gives them no built-in Enter/Space handling — without this a
     keyboard-only customer cannot pick a box size or purchase type at all.
     Click stays bound to the exact same handler, so mouse behavior (and the
     .click() calls build-a-box-pdp.js makes) are unchanged.
     ------------------------------------------------------------------------ */
  function isActivationKey(e) {
    // 'Spacebar' is the legacy Edge/IE key name for ' '.
    return e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar';
  }

  function bindActivation(el, handler) {
    el.addEventListener('click', handler);
    el.addEventListener('keydown', function (e) {
      // Leave OS / browser shortcuts (Alt+Space, Ctrl+Space, Cmd+Enter) alone.
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      if (!isActivationKey(e)) return;
      // Space would otherwise scroll the page out from under the customer.
      e.preventDefault();
      handler();
    });
  }

  /* ========================================================================
     Render Functions
     ======================================================================== */
  function renderTiers() {
    tierCards.forEach(function (card) {
      var tier = parseInt(card.dataset.babTier, 10);
      var selected = tier === state.quantityTier;
      card.classList.toggle('is-selected', selected);
      // Same code path as the visual selected state, so what a screen reader
      // hears can never drift from what the card looks like.
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    // Enable/disable subsequent steps
    if (state.quantityTier) {
      if (stepPurchase) stepPurchase.classList.remove('is-disabled');
      if (stepFlavors) stepFlavors.classList.remove('is-disabled');
    }
  }

  function renderPurchaseType() {
    purchaseCards.forEach(function (card) {
      var selected = card.dataset.babPurchaseType === state.purchaseType;
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    // Update price displays for the selected tier
    if (state.quantityTier) {
      var subPrice = getPriceForTier(state.quantityTier, 'subscribe');
      var onePrice = getPriceForTier(state.quantityTier, 'onetime');
      var recurringPrice = getRecurringPrice(state.quantityTier);
      var subPricing = getSubscriptionPricing(state.quantityTier);

      if (subscribePriceEl) subscribePriceEl.textContent = '$' + Math.round(subPrice / 100);
      if (onetimePriceEl) onetimePriceEl.textContent = '$' + Math.round(onePrice / 100);

      // Show compare price (strikethrough one-time), savings badge, and recurring line
      var comparePriceEl = section.querySelector('[data-bab-subscribe-compare]');
      var savingsBadgeEl = section.querySelector('[data-bab-subscribe-savings]');
      var recurringEl = section.querySelector('[data-bab-subscribe-recurring]');

      if (subPricing && subPrice < onePrice) {
        if (comparePriceEl) {
          setCompareText(comparePriceEl, '$' + Math.round(onePrice / 100));
          comparePriceEl.style.display = 'inline';
        }
        if (savingsBadgeEl) {
          savingsBadgeEl.textContent = CONFIG.subscriptionOffer && CONFIG.subscriptionOffer.isEverSubscriber
            ? 'Save 5% on every box'
            : 'Save 20% on your first-ever box';
          savingsBadgeEl.style.display = 'inline-block';
        }
        if (recurringEl && recurringPrice > 0) {
          recurringEl.textContent = CONFIG.subscriptionOffer && CONFIG.subscriptionOffer.isEverSubscriber
            ? formatMoney(recurringPrice) + '/mo (5% off every box)'
            : 'Then ' + formatMoney(recurringPrice) + '/mo (5% off future boxes)';
          recurringEl.style.display = 'block';
        }
      } else {
        if (comparePriceEl) comparePriceEl.style.display = 'none';
        if (savingsBadgeEl) savingsBadgeEl.style.display = 'none';
        if (recurringEl) recurringEl.style.display = 'none';
      }
    }
  }

  function renderFlavors() {
    var remaining = MAX_ITEMS - state.totalSelected;

    flavorCards.forEach(function (card) {
      var handle = card.dataset.flavorHandle;
      var qty = state.selections[handle] || 0;
      var qtyEl = card.querySelector('[data-bab-qty]');
      var qtyAnnounceEl = card.querySelector('[data-bab-qty-announce]');
      var minusBtn = card.querySelector('[data-bab-decrement]');
      var plusBtn = card.querySelector('[data-bab-increment]');

      // Both writes are guarded on an actual change: the visible count and the
      // announcement live inside one aria-live="polite" region, and rewriting
      // identical text on unrelated re-renders (tier / purchase-type changes)
      // makes screen readers re-read every flavor card.
      if (qtyEl && qtyEl.textContent !== String(qty)) qtyEl.textContent = qty;
      if (qtyAnnounceEl) {
        var announcement = flavorTitleForHandle(handle) + ': ' + qty + ' in box';
        if (qtyAnnounceEl.textContent !== announcement) qtyAnnounceEl.textContent = announcement;
      }
      if (minusBtn) minusBtn.disabled = qty <= 0;
      var flavor = CONFIG.flavors.find(function (f) { return f.handle === handle; });
      var status = CONFIG.flavorSettingsVersion ? window.AlphaMealFlavors.availability(flavor, CONFIG, Math.max(qty, 1), state) : { available: true, message: '' };
      var nextStatus = CONFIG.flavorSettingsVersion ? window.AlphaMealFlavors.availability(flavor, CONFIG, qty + 1, state) : status;
      if (plusBtn) plusBtn.disabled = remaining <= 0 || !nextStatus.available;
      var addBtn = card.querySelector('[data-bab-add-to-box]');
      if (addBtn) {
        addBtn.disabled = remaining <= 0 || !nextStatus.available;
        addBtn.textContent = status.available ? 'ADD TO BOX' : status.kind === 'subscriber_exclusive' ? 'SUBSCRIBER EXCLUSIVE' : 'SOLD OUT';
      }
      var statusEl = card.querySelector('[data-bab-flavor-status]');
      if (statusEl) {
        // The button already says Sold Out; keep only actionable access copy.
        var statusMessage = !status.available && status.kind !== 'sold_out' ? status.message : '';
        statusEl.textContent = statusMessage;
        statusEl.hidden = !statusMessage;
      }
      card.classList.toggle('is-sold-out', !status.available);
      card.classList.toggle('is-subscriber-locked', status.kind === 'subscriber_exclusive');
      card.classList.toggle('has-selections', qty > 0);
    });

    // Progress bar (hidden on PDP, observed by PDP JS for tier slider)
    var pct = (state.totalSelected / MAX_ITEMS) * 100;
    if (progressFill) {
      progressFill.style.width = pct + '%';
      progressFill.classList.toggle('is-complete', MILESTONES.indexOf(state.totalSelected) !== -1);
    }
    if (progressCount) {
      progressCount.textContent = state.totalSelected + ' / ' + MAX_ITEMS;
    }
    if (progressLabel) {
      if (MILESTONES.indexOf(state.totalSelected) !== -1) {
        progressLabel.textContent = 'Ready to checkout!';
      } else {
        var next = MILESTONES.find(function (m) { return m > state.totalSelected; }) || MAX_ITEMS;
        var left = next - state.totalSelected;
        progressLabel.textContent = 'Select ' + left + ' more';
      }
    }
  }

  // The picker is a starting quantity, not a cap on manual flavor choices.
  // Price and submit the actual completed box while leaving the picker usable
  // as the target for the next combo.
  function getCheckoutTier() {
    return MILESTONES.indexOf(state.totalSelected) !== -1 ? state.totalSelected : state.quantityTier;
  }

  function renderSummary() {
    var boxTier = getCheckoutTier();
    if (!summaryItems) return;

    // Clear existing items
    summaryItems.innerHTML = '';

    var hasSelections = false;
    var isPdp = !!section.closest('.bab-pdp');
    CONFIG.flavors.forEach(function (flavor) {
      var qty = state.selections[flavor.handle] || 0;
      if (qty > 0) {
        hasSelections = true;
        var li = document.createElement('li');
        li.className = 'bab-summary__item';
        if (isPdp) {
          var thumbSrc = flavor.image || CONFIG.placeholderImage || '';
          var thumbHtml = thumbSrc
            ? '<div class="bab-summary__item-thumb"><img src="' + thumbSrc + '" alt="" width="52" height="52" loading="lazy"></div>'
            : '';
          li.innerHTML = thumbHtml +
            '<span class="bab-summary__item-name">' + escapeAttr(flavor.title) + '</span>' +
            '<span class="bab-summary__item-controls">' +
              '<button type="button" class="bab-summary__item-ctrl" data-bab-summary-ctrl="' + flavor.handle + '" data-bab-summary-action="decrement" aria-label="Remove one ' + escapeAttr(flavor.title) + '">−</button>' +
              '<span class="bab-summary__item-qty">' + qty + '</span>' +
              '<button type="button" class="bab-summary__item-ctrl" data-bab-summary-ctrl="' + flavor.handle + '" data-bab-summary-action="increment" aria-label="Add one ' + escapeAttr(flavor.title) + '">+</button>' +
            '</span>';
        } else {
          li.innerHTML =
            '<span class="bab-summary__item-name">' + escapeAttr(flavor.title) + '</span>' +
            '<span class="bab-summary__item-qty">x' + qty + '</span>';
        }
        summaryItems.appendChild(li);
      }
    });

    if (summaryEmpty) {
      summaryEmpty.style.display = hasSelections ? 'none' : 'block';
    }

    // Show/hide bottle upsell based on selections
    if (summaryUpsellBottle) {
      summaryUpsellBottle.style.display = hasSelections ? 'block' : 'none';
    }

    // Total price (include bottle upsell if toggled)
    if (boxTier) {
      var price = getPriceForTier(boxTier, state.purchaseType);
      var sidebarToggle = section.querySelector('[data-bab-pdp-upsell-toggle-sidebar]');
      if (sidebarToggle && sidebarToggle.checked && CONFIG.upsell && CONFIG.upsell.available === true) {
        // Bottle is full price for everyone now (no subscriber discount).
        price += CONFIG.upsell.price;
      }
      if (summaryTotal) summaryTotal.textContent = '$' + Math.round(price / 100);
      if (summaryPerMeal) {
        summaryPerMeal.textContent = formatMoney(getPerMealPrice(boxTier, state.purchaseType)) + ' per meal';
      }
    }

    // Dual checkout CTA prices (PDP one-time mode). The "Checkout with
    // subscription" button always reflects subscription pricing, and "Continue
    // with one-time" always reflects one-time pricing — regardless of the
    // currently selected purchase type. When the shaker bottle add-on is
    // toggled on, each CTA includes the bottle at its full price ($32) — the
    // bottle is no longer discounted for subscribers.
    var ctaSubPriceEl = section.querySelector('[data-bab-checkout-subscribe-price]');
    var ctaOnePriceEl = section.querySelector('[data-bab-checkout-onetime-price]');
    if ((ctaSubPriceEl || ctaOnePriceEl) && boxTier) {
      var ctaToggle = section.querySelector('[data-bab-pdp-upsell-toggle-sidebar]');
      var bottleOn = !!(ctaToggle && ctaToggle.checked && CONFIG.upsell && CONFIG.upsell.available === true);
      var ctaSub = getPriceForTier(boxTier, 'subscribe') + (bottleOn ? CONFIG.upsell.price : 0);
      var ctaOne = getPriceForTier(boxTier, 'onetime') + (bottleOn ? CONFIG.upsell.price : 0);
      if (ctaSubPriceEl) ctaSubPriceEl.textContent = formatMoneyShort(ctaSub);
      if (ctaOnePriceEl) ctaOnePriceEl.textContent = formatMoneyShort(ctaOne);
    }

    // Mobile bar
    if (mobilePrice && boxTier) {
      mobilePrice.textContent = formatMoney(getPriceForTier(boxTier, state.purchaseType));
    }
    if (mobileProgress) {
      var next = MILESTONES.find(function (m) { return m >= state.totalSelected; }) || MAX_ITEMS;
      mobileProgress.textContent = state.totalSelected + '/' + next + ' selected';
    }
  }

  function renderValidity() {
    state.isValid = MILESTONES.indexOf(state.totalSelected) !== -1;
    if (state.isValid && CONFIG.flavorSettingsVersion) {
      state.isValid = !window.AlphaMealFlavors.box(CONFIG, state.selections, 1, state).errors.length;
    }

    if (addToCartBtn) addToCartBtn.disabled = !state.isValid;
    // The sticky mobile button is deliberately NOT marked disabled: on an
    // incomplete box it still does something (jumps to the flavor picker), and
    // aria-disabled="true" on a button that acts on tap is a lie. Its label
    // carries the state instead — see updateMobileBar in build-a-box-pdp.js.
  }

  // Same rules drive the flavor cards, box notice, saved properties and cart.
  function selectedPreorderRound() {
    if (CONFIG.flavorSettingsVersion) return window.AlphaMealFlavors.box(CONFIG, state.selections, 1, state).shipping;
    // Preserve the older build-a-box template until it is migrated separately.
    if (!CONFIG.preorder || !CONFIG.preorder.enabled) return null;
    var delayed = CONFIG.flavors.some(function (flavor) {
      return state.selections[flavor.handle] > 0 && flavor.inventoryQuantity <= 0;
    });
    return delayed && CONFIG.preorder.round2 && CONFIG.preorder.round2.date ? CONFIG.preorder.round2 : null;
  }

  function renderPreorderNotice() {
    if (!preorderNotice) return;
    var shipping = selectedPreorderRound();
    preorderNotice.hidden = !shipping;
    preorderNotice.textContent = shipping ? (shipping.message || 'Preorder — this box ships ' + shipping.label) : '';
  }

  function renderAll() {
    renderTiers();
    renderPurchaseType();
    renderFlavors();
    renderSummary();
    renderPreorderNotice();
    renderValidity();
  }

  function announceStateChange(reason) {
    section.dispatchEvent(new CustomEvent('bab:state-change', { detail: { reason: reason, state: state } }));
  }

  // Combos replace one complete box atomically, using the same eligibility and
  // inventory rules as manual additions and checkout.
  function applySelections(selections) {
    if (bundleSubmissionBusy || !selections || typeof selections !== 'object' || Array.isArray(selections)) return false;
    var next = {};
    var total = 0;
    for (var handle of Object.keys(selections)) {
      var quantity = selections[handle];
      if (!Number.isInteger(quantity) || quantity < 0) return false;
      if (!quantity) continue;
      var flavor = CONFIG.flavors.find(function (item) { return item.handle === handle; });
      if (!flavor) return false;
      if (CONFIG.flavorSettingsVersion && !window.AlphaMealFlavors.availability(flavor, CONFIG, quantity, state).available) return false;
      next[handle] = quantity;
      total += quantity;
    }
    if (!total || total !== state.quantityTier || !getVariantForTier(total)) return false;
    state.selections = next;
    recalcTotal();
    renderAll();
    hideError();
    announceStateChange('combo');
    return true;
  }

  /* ========================================================================
     Event Handlers
     ======================================================================== */

  // Tier selection — click and Enter/Space run the identical path
  tierCards.forEach(function (card) {
    bindActivation(card, function () {
      if (bundleSubmissionBusy) return;
      var newTier = parseInt(card.dataset.babTier, 10);
      var variant = getVariantForTier(newTier);

      state.quantityTier = newTier;
      state.selectedVariantId = variant ? variant.id : null;

      recalcTotal();
      updateSellingPlan();
      renderAll();
      hideError();
      announceStateChange('tier');
    });
  });

  // Purchase type selection — click and Enter/Space run the identical path
  purchaseCards.forEach(function (card) {
    bindActivation(card, function () {
      if (bundleSubmissionBusy) return;
      state.purchaseType = card.dataset.babPurchaseType;
      updateSellingPlan();
      var removed = false;
      if (CONFIG.flavorSettingsVersion && !window.AlphaMealFlavors.hasSubscriptionAccess(CONFIG, state)) {
        CONFIG.flavors.forEach(function (flavor) {
          if (flavor.subscriberExclusive && state.selections[flavor.handle]) {
            delete state.selections[flavor.handle];
            removed = true;
          }
        });
        recalcTotal();
      }
      renderAll();
      if (removed) showError('Subscriber-exclusive flavors were removed. Subscribe or sign in with an active subscription to include them.');
      else hideError();
      announceStateChange('purchase-type');
    });
  });

  // Flavor increment/decrement
  flavorCards.forEach(function (card) {
    var handle = card.dataset.flavorHandle;

    card.querySelector('[data-bab-increment]').addEventListener('click', function (e) {
      e.stopPropagation();
      if (bundleSubmissionBusy) return;
      if (state.totalSelected >= MAX_ITEMS) return;
      if (CONFIG.flavorSettingsVersion) {
        var flavor = CONFIG.flavors.find(function (f) { return f.handle === handle; });
        if (!window.AlphaMealFlavors.availability(flavor, CONFIG, (state.selections[handle] || 0) + 1, state).available) return;
      }

      state.selections[handle] = (state.selections[handle] || 0) + 1;
      recalcTotal();
      autoSelectTierForMilestone();
      renderAll();
      hideError();
      announceStateChange('selection');
    });

    card.querySelector('[data-bab-decrement]').addEventListener('click', function (e) {
      e.stopPropagation();
      if (bundleSubmissionBusy) return;
      if (!state.selections[handle] || state.selections[handle] <= 0) return;

      state.selections[handle] -= 1;
      if (state.selections[handle] === 0) delete state.selections[handle];
      recalcTotal();
      autoSelectTierForMilestone();
      renderAll();
      announceStateChange('selection');
    });
  });

  // Add to cart (fires cancelable event so PDP JS can intercept for popups)
  function handleAddToCart() {
    if (!state.isValid) return;
    var evt = new CustomEvent('bab:beforeAddToCart', { cancelable: true });
    var allowed = section.dispatchEvent(evt);
    if (allowed) addToCart();
  }

  if (addToCartBtn) addToCartBtn.addEventListener('click', handleAddToCart);
  if (mobileBtn) mobileBtn.addEventListener('click', function () {
    // An incomplete box can't check out, so the button jumps to the flavor
    // picker instead — same behavior as before, now gated on the real state
    // rather than on an aria-disabled attribute that no longer exists.
    if (!state.isValid) {
      var flavorsSection = document.getElementById('bab-pdp-flavors');
      if (flavorsSection) flavorsSection.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    handleAddToCart();
  });

  /* ========================================================================
     State Helpers
     ======================================================================== */
  function recalcTotal() {
    state.totalSelected = 0;
    for (var handle in state.selections) {
      state.totalSelected += state.selections[handle];
    }
  }

  function updateSellingPlan() {
    if (state.purchaseType === 'subscribe' && CONFIG.sellingPlanId) {
      state.sellingPlanId = CONFIG.sellingPlanId;
    } else {
      state.sellingPlanId = null;
    }
  }

  var MILESTONES = [12, 18, 30];
  var MAX_ITEMS = 30;

  function autoSelectTierForMilestone() {
    if (MILESTONES.indexOf(state.totalSelected) !== -1) {
      var variant = getVariantForTier(state.totalSelected);
      if (variant) {
        state.quantityTier = state.totalSelected;
        state.selectedVariantId = variant.id;
        updateSellingPlan();
      }
    }
  }

  /* ========================================================================
     Recharge SDK + Cart Submission
     ======================================================================== */
  // Confirm a Recharge selection before any cart writes. Retries never submit
  // products, and a late SDK response after the deadline cannot submit a cart.
  var bundleSubmissionBusy = false;
  var rechargeReload = null;

  function bundleDelay(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function bundleWithin(task, ms) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error('recharge_timeout')); }, Math.max(1, ms));
      Promise.resolve().then(task).then(function (value) {
        clearTimeout(timer);
        resolve(value);
      }, function (error) {
        clearTimeout(timer);
        reject(error);
      });
    });
  }

  async function bundleClient(deadline) {
    if (!window.recharge || !window.recharge.bundle) {
      // A failed deferred CDN script will not load just because the API is retried.
      // Retry that same script once, sharing its promise with repeated attempts.
      if (!rechargeReload) {
        rechargeReload = new Promise(function (resolve, reject) {
          var original = document.querySelector('script[src*="static.rechargecdn.com/assets/storefront/recharge-client-"]');
          if (!original) { reject(new Error('recharge_script_missing')); return; }
          var script = document.createElement('script');
          script.src = original.src;
          script.async = true;
          script.onload = resolve;
          script.onerror = function () { script.remove(); reject(new Error('recharge_script_unavailable')); };
          document.head.appendChild(script);
        });
      }
      await bundleWithin(function () { return rechargeReload; }, Math.min(3500, deadline - Date.now()));
    }
    if (typeof window.__babInitializeRecharge === 'function') window.__babInitializeRecharge();
    if (!window.recharge || !window.recharge.bundle || typeof window.recharge.bundle.getBundleId !== 'function') {
      throw new Error('recharge_sdk_unavailable');
    }
    return window.recharge;
  }

  async function confirmedBundleId(bundle) {
    var deadline = Date.now() + 12000;
    // Snapshot once: every attempt must represent the very same box.
    var selection = JSON.parse(JSON.stringify(bundle));
    rechargeReload = null;
    for (var attempt = 0; attempt < 3 && Date.now() < deadline; attempt++) {
      try {
        var client = await bundleClient(deadline);
        if (Date.now() >= deadline) throw new Error('recharge_timeout');
        var id = await bundleWithin(function () {
          return client.bundle.getBundleId(selection);
        }, Math.min(3500, deadline - Date.now()));
        if (typeof id === 'string' && id.trim()) return id.trim();
        throw new Error('recharge_empty_bundle_id');
      } catch (error) {
        // No customer data or selections in diagnostics.
        console.warn('[BuildABox] Bundle confirmation attempt ' + (attempt + 1) + ' failed', error && error.name || 'Error');
        if (attempt < 2 && Date.now() < deadline) {
          await bundleDelay(Math.min(400 * (attempt + 1), deadline - Date.now()));
        }
      }
    }
    throw new Error('We couldn’t finish preparing your box. Your selections are saved on this page—please try again.');
  }

  function setBundleControlsBusy() {
    var controls = Array.from(section.querySelectorAll('button, input, select, textarea'));
    if (mobileBar) controls = controls.concat(Array.from(mobileBar.querySelectorAll('button, input, select')));
    var previous = controls.map(function (el) { return [el, el.disabled]; });
    controls.forEach(function (el) { el.disabled = true; });
    section.setAttribute('aria-busy', 'true');
    return function () {
      previous.forEach(function (entry) { entry[0].disabled = entry[1]; });
      section.removeAttribute('aria-busy');
    };
  }

  async function addToCart() {
    if (!state.isValid || bundleSubmissionBusy) return;
    // A customer can change the picker after building a complete box. Charge
    // for the actual meal count, not the previously requested combo size.
    autoSelectTierForMilestone();
    renderAll();
    bundleSubmissionBusy = true;
    var restoreControls = setBundleControlsBusy();
    var mobileLabel = mobileBtn ? mobileBtn.textContent : null;

    var btn = addToCartBtn;
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-loading');
    }
    if (mobileBtn) {
      mobileBtn.disabled = true;
      mobileBtn.textContent = 'Preparing your box…';
    }
    hideError();

    try {
      if (CONFIG.flavorSettingsVersion) {
        var fresh = await window.AlphaMealFlavors.load(CONFIG.productUrl, CONFIG.sectionId);
        if (String(fresh.productId) !== String(CONFIG.productId)) throw new Error('Please refresh and rebuild your box.');
        CONFIG.flavors = fresh.flavors;
        CONFIG.preorder = fresh.preorder;
        CONFIG.checkoutNotice = fresh.checkoutNotice;
        CONFIG.today = fresh.today;
        CONFIG.subscriptionAccess = fresh.subscriptionAccess;
        CONFIG.sellingPlanId = fresh.sellingPlanId;
        CONFIG.sellingPlans = fresh.sellingPlans;
        updateSellingPlan();
        renderFlavors();
        renderPreorderNotice();
        renderValidity();
        announceStateChange('refresh');
        if (state.purchaseType === 'subscribe' && !state.sellingPlanId) {
          throw new Error('Subscriptions are temporarily unavailable. Please refresh and try again.');
        }
        var validation = window.AlphaMealFlavors.box(CONFIG, state.selections, 1, state);
        if (validation.errors.length) throw new Error(validation.errors.join(' '));
      }
      // Build selections array for Recharge SDK
      var selections = [];
      CONFIG.flavors.forEach(function (flavor) {
        var qty = state.selections[flavor.handle];
        if (qty && qty > 0) {
          selections.push({
            // Recharge's SDK expects the SHOPIFY (external) collection id here, not
            // Recharge's internal collection id. Passing the internal id (162983)
            // makes the bundle selection fail validation at order time, so child
            // flavor line items never expand onto the order and inventory never
            // decrements. Fall back to the Recharge id only if the Shopify id is
            // somehow absent from config.
            collectionId: String(CONFIG.shopifyCollectionId || CONFIG.rechargeCollectionId),
            externalProductId: String(flavor.productId),
            externalVariantId: String(flavor.variantId),
            quantity: qty,
          });
        }
      });

      // Safety net: never submit a flavorless bundle. If CONFIG.flavors failed
      // to load (e.g. the bundle collection momentarily returned no products),
      // the on-screen box can look valid while producing no cart data. Fail
      // loudly here instead of shipping an order with no flavors.
      if (selections.length === 0) {
        throw new Error('We couldn’t read your flavor selections. Please refresh the page and rebuild your box.');
      }

      // Get the numeric variant ID (strip gid prefix if present)
      var variantId = state.selectedVariantId;
      if (typeof variantId === 'string' && variantId.indexOf('gid://') === 0) {
        variantId = variantId.split('/').pop();
      }
      // Ensure it's a number for cart API
      variantId = Number(variantId);
      if (!variantId) {
        throw new Error('No variant selected. Please select a tier.');
      }
      console.log('[BuildABox] Adding variant:', variantId, 'state:', JSON.stringify(state));

      // Group id shared by this box line and its flavor component lines, so the
      // cart can remove the (hidden) components when the box is removed and so
      // components from different boxes don't merge into one line.
      var bundleGroupId = 'bab-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);

      var cartItem = {
        id: variantId,
        quantity: 1,
        properties: { _bundle_id: bundleGroupId },
      };

      var preorderRound = selectedPreorderRound();
      if (CONFIG.flavorSettingsVersion) {
        cartItem.properties._bab_flavors = JSON.stringify(CONFIG.flavors.filter(function (f) {
          return state.selections[f.handle] > 0;
        }).map(function (f) { return { variantId: String(f.variantId), quantity: state.selections[f.handle] }; }));
        cartItem.properties._bab_section_id = CONFIG.sectionId;
        cartItem.properties = window.AlphaMealFlavors.propertiesForShipping(cartItem.properties, preorderRound);
      } else if (preorderRound) {
        cartItem.properties._preorder_ship_date = preorderRound.date;
        cartItem.properties._preorder_ship_label = preorderRound.label || '';
      }

      // Add selling plan for subscriptions
      if (state.sellingPlanId) {
        var planId = state.sellingPlanId;
        if (typeof planId === 'string' && planId.indexOf('gid://') === 0) {
          planId = planId.split('/').pop();
        }
        cartItem.selling_plan = planId;
      }

      // Write human-readable flavor counts as VISIBLE line-item properties so the
      // flavors show on the box line at Shopify CHECKOUT, in the cart/drawer, and
      // on the order in admin. Keyed "<qty> x <title>" (e.g. "4 x Wildberry
      // Waffle") so checkout renders them quantity-first. Shopify checkout renders
      // a property as "<name>: <value>" and HIDES it when the value is blank, so
      // the value is a non-breaking space — non-blank (property still shows) but
      // visually empty, so the visible text is just the "<qty> x <title>" key.
      CONFIG.flavors.forEach(function (flavor) {
        var qty = state.selections[flavor.handle];
        if (qty && qty > 0) {
          cartItem.properties[qty + ' x ' + flavor.title] = '\u00A0';
        }
      });

      // Keep the checkout notice after the flavor properties in the summary.
      if (CONFIG.flavorSettingsVersion) {
        cartItem.properties = window.AlphaMealFlavors.propertiesForCheckoutNotice(cartItem.properties, CONFIG.checkoutNotice);
      }

      // Add each chosen flavor as a real $0 line item so Shopify natively
      // decrements + commits flavor inventory on this first order (Recharge
      // re-expands the flavors itself on every renewal via the bundle_selection,
      // so we only need to fix order #1 here). These are ONE-TIME lines (no
      // selling_plan) so Recharge doesn't spin up parallel flavor subscriptions,
      // and they're flagged _bundle_component so the cart drawer hides them
      // under the box line.
      // The flavor component lines and any upsell are added AFTER the box, in a
      // SEPARATE request, so the box line is always created first. Shopify does
      // not guarantee line ordering within a single multi-item /cart/add.js call
      // (merged/new lines can land out of order), which would put flavors above
      // the box at checkout. Adding the box alone first, then awaiting, then
      // adding the rest, gives a deterministic order: box → flavors → merch.
      var componentItems = [];
      // TEMPORARILY DISABLED (test): stop adding each chosen flavor as a real $0
      // component line item. Re-enable by uncommenting the loop below to restore
      // first-order flavor inventory decrement. See bundle-flavor-inventory-line-items.
      /*
      CONFIG.flavors.forEach(function (flavor) {
        var flavorQty = state.selections[flavor.handle];
        if (!flavorQty || flavorQty <= 0) return;
        var flavorVariantId = flavor.variantId;
        if (typeof flavorVariantId === 'string' && flavorVariantId.indexOf('gid://') === 0) {
          flavorVariantId = flavorVariantId.split('/').pop();
        }
        flavorVariantId = Number(flavorVariantId);
        if (!flavorVariantId) return;
        componentItems.push({
          id: flavorVariantId,
          quantity: flavorQty,
          properties: { _bundle_component: '1', _bundle_id: bundleGroupId },
        });
      });
      */

      // Check if PDP upsell toggle is checked — add bottle as separate line item
      var upsellToggle = document.querySelector('[data-bab-pdp-upsell-toggle]') || document.querySelector('[data-bab-pdp-upsell-toggle-sidebar]');
      if (upsellToggle && upsellToggle.checked && CONFIG.upsell && CONFIG.upsell.available === true) {
        var upsellVariantId = CONFIG.upsell.variantId;
        if (typeof upsellVariantId === 'string' && upsellVariantId.indexOf('gid://') === 0) {
          upsellVariantId = upsellVariantId.split('/').pop();
        }
        var numericUpsellId = Number(upsellVariantId);
        if (numericUpsellId) {
          componentItems.push({ id: numericUpsellId, quantity: 1 });
        }
      }

      cartItem.properties._rb_id = await confirmedBundleId({
        externalProductId: String(CONFIG.productId),
        externalVariantId: String(variantId),
        selections: selections,
      });

      // 1) Add the box first and wait for it to land so it sits above the flavors.
      console.log('[BuildABox] Cart request (box):', JSON.stringify({ items: [cartItem] }));
      var boxResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [cartItem] }),
      });

      if (!boxResponse.ok) {
        var boxErr = await boxResponse.json().catch(function () { return {}; });
        console.error('[BuildABox] Cart error response (box):', JSON.stringify(boxErr));
        throw new Error(boxErr.description || boxErr.message || 'Failed to add to cart');
      }

      // 2) Add the flavor component lines + any upsell after the box.
      if (componentItems.length) {
        console.log('[BuildABox] Cart request (components):', JSON.stringify({ items: componentItems }));
        var componentsResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: componentItems }),
        });

        if (!componentsResponse.ok) {
          var compErr = await componentsResponse.json().catch(function () { return {}; });
          console.error('[BuildABox] Cart error response (components):', JSON.stringify(compErr));
          throw new Error(compErr.description || compErr.message || 'Failed to add to cart');
        }
      }

      // Success — redirect to cart
      window.location.href = '/cart';
    } catch (err) {
      bundleSubmissionBusy = false;
      restoreControls();
      console.error('[BuildABox] Add to cart failed:', err);
      showError(err.message || 'Something went wrong. Please try again.');

      if (btn) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }
      // The sticky mobile CTA is disabled alongside the desktop button when the
      // submission starts, so it has to be re-enabled here too — otherwise a
      // failed add-to-cart leaves phone visitors with a dead button and no way
      // to retry.
      if (mobileBtn) {
        mobileBtn.disabled = false;
        mobileBtn.textContent = mobileLabel;
      }
      if (CONFIG.flavorSettingsVersion) {
        renderAll();
        announceStateChange('refresh');
      }
    }
  }

  /* ========================================================================
     Initialize
     ======================================================================== */
  // Set initial selling plan
  updateSellingPlan();
  renderAll();

  // Default the tier selection on load. Prefer the 18-meal tier; fall back to the
  // first variant (which also covers the single-tier case). Only pre-selects the
  // tier card + pricing — flavors still start empty, and autoSelectTierForMilestone
  // won't override this until the user's flavor count actually hits a milestone.
  var defaultVariant = null;
  for (var vi = 0; vi < CONFIG.variants.length; vi++) {
    if (CONFIG.variants[vi].quantity === 18) {
      defaultVariant = CONFIG.variants[vi];
      break;
    }
  }
  if (!defaultVariant) defaultVariant = CONFIG.variants[0];
  if (defaultVariant) {
    state.quantityTier = defaultVariant.quantity;
    state.selectedVariantId = defaultVariant.id;
    renderAll();
  }

  // Expose state and helpers for PDP-specific checkout flow (build-a-box-pdp.js)
  window.__babState = state;
  window.__babAddToCart = addToCart;
  window.__babGetPriceForTier = getPriceForTier;
  window.__babGetCheckoutTier = getCheckoutTier;
  window.__babGetSubscriptionPricing = getSubscriptionPricing;
  window.__babConfig = CONFIG;
  window.__babApplySelections = applySelections;

  /* ========================================================================
     bfcache reset
     ------------------------------------------------------------------------
     Mobile browsers (iOS Safari / Android Chrome) restore this page from the
     back/forward cache when the user taps "Back" from the cart. The frozen DOM
     and in-memory state come back with the box still populated, and this script
     does not re-run — so the box looks like it's still holding items that were
     already added to the cart. Desktop does a fresh load and clears naturally.
     Force a fresh load on bfcache restore so the box always starts empty.
     ======================================================================== */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  }, { signal: lifecycle.signal });
})();
